import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight, Check } from "lucide-react";
import { api } from "../lib/api";

export const NewsletterForm = ({ source = "site", compact = false }) => {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/newsletter", {
        email,
        phone: phone || undefined,
        source,
      });
      setDone(true);
      toast.success("You're on the list. First access unlocked.");
    } catch {
      toast.error("Signup failed — try again.");
    } finally {
      setBusy(false);
    }
  };

  if (done)
    return (
      <div
        data-testid="newsletter-success"
        className="flex items-center gap-3 border border-signal/50 bg-signal/10 px-4 py-3.5"
      >
        <Check className="h-4 w-4 text-signal" />
        <span className="font-mono text-xs uppercase tracking-[0.2em] text-signal">
          You're on the list
        </span>
      </div>
    );

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="w-full">
      <div className="flex border-b border-border transition-colors focus-within:border-signal">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="EMAIL ADDRESS"
          data-testid="newsletter-email-input"
          className="w-full bg-transparent py-3.5 font-mono text-xs uppercase tracking-[0.2em] placeholder:text-muted-foreground focus:outline-none"
        />
        <button
          type="submit"
          disabled={busy}
          data-testid="newsletter-submit-button"
          aria-label="Subscribe"
          className="px-3 text-muted-foreground transition-colors hover:text-signal disabled:opacity-40"
        >
          <ArrowRight className="h-4 w-4" />
        </button>
      </div>
      {!compact && (
        <input
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="PHONE (OPTIONAL — SMS DROPS)"
          data-testid="newsletter-phone-input"
          className="mt-4 w-full border-b border-border bg-transparent py-3.5 font-mono text-xs uppercase tracking-[0.2em] placeholder:text-muted-foreground focus:border-signal focus:outline-none"
        />
      )}
    </form>
  );
};
